import React, { useEffect, useState } from "react";
import TagInputs from "../../inputs/TagInputs";
import { put } from "../../../utility/fetch";
import toast from "react-hot-toast";
import axios from "axios";

const SettingEmergencyContact = ({ nextStep, data, pic, name, email, id }) => {
    const [payload, setPayload] = useState({
        relationship: data?.relationship || "",
        firstName: data?.firstName || "",
        lastName: data?.lastName || "",
        phone: data?.phone || "",
        email: data?.email || "",
        contactAddress: data?.contactAddress || "",
        stateOfResidence: data?.stateOfResidence || "",
        lga: data?.lga || "",
        city: data?.city || "",
        altPhone: data?.altPhone || "",
    });
    const [groupLoading, setGroupLoading] = useState(false);
    const [states, setStates] = useState([]);
    const [lgas, setLgas] = useState([]);
    const [state, setState] = useState({
        label: data?.stateOfResidence || "Select State",
        value: data?.stateOfResidence || "",
    });
    const [lga, setLga] = useState({
        label: data?.lga || "Select LGA",
        value: data?.lga || "",
    });

    const getStates = async () => {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/connectedhealthlabapi/api/hmo/state/list`);
        if (res?.data?.statusCode === 200) {
            let tempDoc = res?.data?.data?.map((doc) => {
                return { label: doc?.name, value: doc?.id };
            });
            tempDoc?.unshift({ label: "Select State", value: "" });
            setStates(tempDoc);
        }
    };

    const getLga = async (id) => {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/connectedhealthlabapi/api/healthcareprovider/getlgasbystateid/id/${id}`);
        if (res?.data) {
            let tempDoc = res?.data?.map((doc) => {
                return { label: doc?.lga, value: doc?.id };
            });
            tempDoc?.unshift({ label: "Select LGA", value: "" });
            setLgas(tempDoc);
        }
    };

    const handleChange = (field, value) => {
        if (field === "stateOfResidence") {
            setPayload({ ...payload, [field]: value.label });
            setState(value);
            getLga(Number(value?.value));
        } else if (field === "lga") {
            setPayload({ ...payload, [field]: value.label });
            setLga(value);
        } else {
            setPayload({ ...payload, [field]: value });
        }
    };

    const updateProfile = async () => {
        setGroupLoading(true);
        const response = await put(`/Patient/${id}/emergency-contact-update`, payload);
        if (response.statusCode === 200) {
            toast.success("You have successfully updated your emergency contact");
        } else {
            toast.error("Error updating emergency contact");
        }
        setGroupLoading(false);
    };

    useEffect(() => {
        getStates();
    }, []);

    return (
        <div className="card p-40">
            <div className="profile-header m-b-40 flex space-between">
                <div className="flex">
                    <img src={pic || "user-avater.png"} alt="User" className="profile-pic" />
                    <div className="m-l-10">
                        <h3>{`${name || ""}`}</h3>
                        <p>{email || ""}</p>
                    </div>
                </div>
                <button
                    disabled={groupLoading}
                    className="save-drafts col-3"
                    onClick={updateProfile}
                >
                    Save Changes
                </button>
            </div>

            <h2 className="m-b-10">Emergency Contact</h2>
            <div className="flex space-between">
                <form className="profile-form col-6">
                    <div className="form-group">
                        <TagInputs
                            label="Relationship"
                            type="text"
                            value={payload.relationship}
                            onChange={(e) => handleChange("relationship", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="First Name"
                            type="text"
                            value={payload.firstName}
                            onChange={(e) => handleChange("firstName", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="Last Name"
                            type="text"
                            value={payload.lastName}
                            onChange={(e) => handleChange("lastName", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="Phone"
                            type="text"
                            value={payload.phone}
                            onChange={(e) => handleChange("phone", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="Email"
                            type="text"
                            value={payload.email}
                            onChange={(e) => handleChange("email", e.target.value)}
                        />
                    </div>
                </form>
                <form className="profile-form col-6">
                    <div className="form-group">
                        <TagInputs
                            label="Contact Address"
                            type="text"
                            value={payload.contactAddress}
                            onChange={(e) => handleChange("contactAddress", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="State of Residence"
                            type="R-select"
                            options={states}
                            value={state}
                            onChange={(e) => handleChange("stateOfResidence", e)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="LGA"
                            type="R-select"
                            options={lgas}
                            value={lga}
                            onChange={(e) => handleChange("lga", e)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="City"
                            type="text"
                            value={payload.city}
                            onChange={(e) => handleChange("city", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="Alternate Phone"
                            type="text"
                            value={payload.altPhone}
                            onChange={(e) => handleChange("altPhone", e.target.value)}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SettingEmergencyContact;